<template>
  <div>
    <div id="televersement__warnings" class="pb-2 d-none">
      <ul class="pl-0">
        <li id="warning-televersement-final" class="warning p-2 d-none"></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import mixinMessageErreur from '@/mixins/mixinMessageErreur';

export default {
  name: 'TeleversementWarnings',
  mixins: [mixinMessageErreur],
  data() {
    return {
      codeWarning: {
        fichiersFinaux: this.$i18n.t('validations.televersement.fichiersFinaux'),
      },
      listIdWarning: ['warning-televersement-final'],
    };
  },
  computed: {
    ...mapGetters(['getAccountUserMessages']),
  },
  mounted() {
    // TODO: Recoder en parcourant les éléments de "@nodes"
    let i = 0;
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const key in this.codeWarning) {
      this.mixinMessageErreur_getMessage(this.codeWarning[key], key, this.listIdWarning[i]);

      i++;
    }
  },
};
</script>
